import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import {SlideDown} from 'react-slidedown'
import Loader from 'react-loader'
import config from '../../config'
import {
  Link,
  LinkIcon
} from '../'
import Styles from './ScreenedCompanies.css'
import * as searchActions from 'redux/modules/search'


@CSSModules(Styles, {allowMultiple: true})
class ScreenedCompaniesCard extends Component {
  constructor(props){
    super(props)
    this.state = {
      viewMoreCo: false,
      viewMoreOg: false,
      viewMoreMc50: false,
      viewMoreUt: false,
      viewMoreFfb: false,
      viewMoreFfi: false,
      viewMoreCl: false,
    }
  }
  //
  clickViewMore = (lbl) =>{
    const stateLbl = 'viewMore' + lbl
    const newState = {}
    newState[stateLbl] = !this.state[stateLbl]
    this.setState(newState)
  }
  //
  render() {
    //
    const viewMoreTxt = (v) => {
      return v ? 'View less' : 'View companies'
    }

    const labels = {
      'co': viewMoreTxt(this.state.viewMoreCo),
      'og': viewMoreTxt(this.state.viewMoreOg),
      'mc50': viewMoreTxt(this.state.viewMoreMc50),
      'ut': viewMoreTxt(this.state.viewMoreUt),
      'ffb': viewMoreTxt(this.state.viewMoreFfb),
      'ffi': viewMoreTxt(this.state.viewMoreFfi),
      'cl': viewMoreTxt(this.state.viewMoreCl)
    }
    //
    const e = this.props.e
    const icon = this.props.icon
    //
    const id = e[0]
    const title = e[1]
    const text = e[2]
    const isHi = e[3]
    const hasCompanies = e[4]
    const hasAltSlidedown = e[5]
    const altElem = e[6]
    //
    const uppercaseId = id.charAt(0).toUpperCase() + id.slice(1)
    //
    let label = null
    let viewMore = null
    let companies = null
    if (hasCompanies || hasAltSlidedown) {
      label = labels[id]
      viewMore = this.state[`viewMore${uppercaseId}`]
    }
    if (hasCompanies) {
      companies = this.props.getCompanies(id)
    }
    //
    if (this.props.clean200 && hasCompanies && companies) {
      return <ScreenedCompaniesTable companies={companies} />
    }

    return <div styleName='screen-card'>
      <img
        styleName='screen-icon'
        alt={title}
        src={icon}
      />
      <div styleName='screen-icon-label'>
        <p>
          <strong styleName='screen-icon-title'>{title}</strong>
          <br/>
          {text}
        </p>
        {
          isHi ?
            <p>
              <LinkIcon nospace faclass='fa-exclamation-triangle'/>&nbsp;<b><i>HIGHER RISK</i></b>
              <br/>
              Investment in these companies automatically earns a fund a fossil fuel grade of C or lower.
            </p> :
            null
        }
        {
          hasCompanies || hasAltSlidedown ?
            <div>
              <button
                styleName='company-table-button'
                onClick={()=>{ this.clickViewMore(uppercaseId) }}
                title={label}
              >
                {label}
                <LinkIcon
                  faclass={viewMore ? 'fa-angle-up' : 'fa-angle-down'}
                />
              </button>
              <SlideDown>
                {
                  hasCompanies && viewMore ?
                    <ScreenedCompaniesTable companies={companies} /> :
                    null
                }
                {
                  hasAltSlidedown && viewMore ?
                    altElem :
                    null
                }
              </SlideDown>
            </div> :
            altElem
        }
      </div>
    </div>
  }
}


@CSSModules(Styles, {allowMultiple: true})
class ScreenedCompaniesTable extends Component {
  static propTypes = {
    companies: PropTypes.array.isRequired
  }
  constructor(props){
    super(props)
  }
  render() {
    return (
      <table styleName='t-table'>
        <thead>
          <tr>
            <th>Company</th>
            <th>Symbol</th>
            <th>Legal name</th>
          </tr>
        </thead>
        <tbody>
          {
            this.props.companies.map((c, i)=>{
              return (
                <tr key={'to_'+i}>
                  <td>{c.short_name}</td>
                  <td>{c.primary_symbol}</td>
                  <td>{c.legal_name}</td>
                </tr>
              )
            })
          }
        </tbody>
      </table>
    )
  }
}


@connect(
  state => ({
    result: state.company.result,
    searching: state.company.loading,
    searched: state.company.loaded,
    error: state.company.error
  }),
  searchActions)
@CSSModules(Styles, {allowMultiple: true})
export default class ScreenedCompanies extends Component {
  static propTypes = {
    searching: PropTypes.bool,
    searched: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.array,
    // search: PropTypes.func,
  }

  constructor(props){
    super(props)
    this.state = {}
  }

  componentWillMount() {
    this.props.companies()
  }

  componentWillReceiveProps(props){
    if (props.result) {
      let coCompanies = []
      let ogCompanies = []
      let mc50Companies = []
      let utCompanies = []
      let clCompanies = []
      props.result.map((el)=>{
        if (el.is_co) coCompanies.push(el)
        if (el.is_og) ogCompanies.push(el)
        if (el.is_f15) mc50Companies.push(el)
        if (el.is_ut) utCompanies.push(el)
        if (el.is_cl) clCompanies.push(el)
        return false
      })
      const _sorter = (a, b)=>{
        const lbl = 'short_name'
        const a_s = a[lbl].toLowerCase()
        const b_s = b[lbl].toLowerCase()
        return a_s.localeCompare(b_s)
      }
      coCompanies = coCompanies.sort(_sorter)
      ogCompanies = ogCompanies.sort(_sorter)
      mc50Companies = mc50Companies.sort(_sorter)
      utCompanies = utCompanies.sort(_sorter)
      clCompanies = clCompanies.sort(_sorter)
      this.setState({
        coCompanies,
        ogCompanies,
        mc50Companies,
        utCompanies,
        clCompanies
      })
    }
  }
  //
  render() {
    if (!this.props.result) {
      return (
        <div styleName='main'>
          <Loader
            options={{scale: 0.70, top:'4.0rem'}}
            loaded={ false }
          />
        </div>
      )
    }

    const icons = {
      'c2':   require('../../../static/images/icn-c2-active-black.svg'),
      'co':   require('../../../static/images/icn-co-active-black.svg'),
      'og':   require('../../../static/images/icn-og-active-black.svg'),
      'mc50': require('../../../static/images/icn-f5-active-black.svg'), // fix fn
      'ut':   require('../../../static/images/icn-ut-active-black.svg'),
      'ffb':  require('../../../static/images/icn-ffb-active-black.svg'),
      'ffi':  require('../../../static/images/icn-ffi-active-black.svg'),
      'cl':   require('../../../static/images/clean-200-icon.png') // fix fn
    }

    const fossilFuelLendingCompanyTable = require( '../../../static/images/fossil-fuel-lending-company-table.png' )
    const fossilFuelInsuranceCompanyTable = require( '../../../static/images/fossil-fuel-insurance-company-table.png' )

    const fossilFuelCompaniesConfig = [
      [
        'c2',
        'Top carbon reserve owners',
        (<span><Link xstrong to={config.links.fficu200} title='Carbon Underground 200'>The Carbon Underground 200™</Link>, compiled and maintained by FFI Solutions, identifies the top 100 coal and the top 100 oil and gas publicly-traded reserve holders globally, ranked by the potential carbon emissions content of their reported reserves.</span>),
        1, // 1 if higher risk,
        0, // 1 if has company table,
        0, // 1 if has alt slidedown,
        <button styleName='company-table-button'>
          <Link
            to={config.links.fficu200}
            title='Carbon Underground 200 | FFI Solutions'
          >
              View companies <LinkIcon />
          </Link>
        </button>
      ],
      [
        'co',
        'Coal industry',
        (<span>The coal industry screen consists of companies designated by <Link xstrong to={config.routes.morningstar} title='Morningstar industry classifications'>Morningstar industry classifications</Link> as Thermal Coal or Coking Coal; companies from the <Link xstrong to={config.links.gcel} title='Global Coal Exit List'>Global Coal Exit List</Link> marked as Mining or Services for Coal Industry Sector; and the top 100 coal reserve holders from the <Link xstrong to={config.links.fficu200} title='Carbon Underground 200'>Carbon Underground 200™</Link>.</span>),
        0, // 1 if higher risk,
        1, // 1 if has company table,
        0, // 1 if has alt slidedown,
        0, // elem if has alt elem
      ],
      [
        'og',
        'Oil/gas industry',
        (<span>The oil/gas screen consists of companies designated by <Link xstrong to={config.routes.morningstar} title='Morningstar industry classifications'>Morningstar industry classifications</Link> as Oil and Gas Drilling, Oil and Gas Extraction and Production, Oil and Gas Equipment and Services, Oil and Gas Integrated, Oil and Gas Midstream, and Oil and Gas Refining and Marketing; upstream and midstream companies from the <Link xstrong to={config.links.gogel} title='Global Oil/Gas Exit List'>Global Oil/Gas Exit List</Link>; and the top 100 oil/gas reserve holders from the <Link xstrong to={config.links.fficu200} title='Carbon Underground 200'>Carbon Underground 200™</Link>.</span>),
        0, // 1 if higher risk,
        1, // 1 if has company table,
        0, // 1 if has alt slidedown,
        0, // elem if has alt elem
      ],
      [
        'mc50',
        'Top coal-fired utilities',
        (<span>The <Link xstrong to={config.routes.macroclimate50} title='Macroclimate 50®'>Macroclimate® 50</Link> is a list of the 50 largest public-company owners of coal-fired power plants in developed markets plus China and India. Macroclimate compiled the list of 50 companies using open-source data on coal-fired power plants worldwide.</span>),
        1, // 1 if higher risk,
        0, // 1 if has company table,
        0, // 1 if has alt slidedown,
        <button styleName='company-table-button'>
          <Link
            to={config.links.fficu200}
            title='Macroclimate 50 | Macroclimate'
          >
              View companies <LinkIcon />
          </Link>
        </button>
      ],
      [
        'ut',
        'Fossil-fired utilities',
        (<span>The fossil-fired utilities screen consists of companies designated by <Link xstrong to={config.routes.morningstar} title='Morningstar industry classifications'>Morningstar industry classifications</Link> as Utilities-Independent Power Producers, Utilities-Renewable, Utilities-Diversified, Utilities-Regulated Electric, and Utilities-Regulated Gas. (Despite the name, the Utilities-Renewable industry classification includes companies that distribute gas and/or burn fossil fuel for power generation.) It also includes companies from the <Link xstrong to={config.links.gcel} title='Global Coal Exit List'>Global Coal Exit List</Link> marked as Power for Coal Industry Sector. We remove any companies in these categories that are engaged in 100% renewable operations, pure transmission, or otherwise don't distribute gas or burn fossil fuels to generate power. We also remove a small number of utilities that have fossil fuel operations but meet the criteria for inclusion on our Clean200 screen - USD revenue of at least $1 billion, and over 50% of total revenues are from green sources, as measured by Corporate Knights Research.</span>),
        0, // 1 if higher risk,
        1, // 1 if has company table,
        0, // 1 if has alt slidedown,
        0, // elem if has alt elem
      ],
    ]

    const fossilFinanceCompaniesConfig = [
      [
        'ffb',
        'Fossil fuel finance',
        (<span>The fossil fuel finance screen consists of
            60 of the largest
            commercial and investment banks,
            from the <Link
              to='https://www.bankingonclimatechaos.org/'
              title='Banking on Climate Chaos'
              xstrong
            >
              Banking on Climate Chaos
            </Link> report.
            The data tracks the total fossil fuel financing of these banks
            over 2016-2023:
            lending, and underwriting
            debt and equity issuances.
            For our fund ratings, we normalize the bank financing
            amounts from $USD to a 0-10
            scale, where 10 is the worst score possible.
            These 0-10 figures represent a <b>company fossil fuel finance risk
            score</b>.</span>),
        0, // 1 if higher risk,
        0, // 1 if has company table,
        1, // 1 if has alt slidedown,
        (<div styleName='finance-company-table-img-wrap'>
          <img
            src={fossilFuelLendingCompanyTable}
            alt='Fossil fuel finance company table'
            styleName='finance-company-table-img'
          />
        </div>)
      ],
      [
        'ffi',
        'Fossil fuel insurance',
        (<span>The fossil fuel insurance screen consists of
            30 of the largest primary insurers and reinsurers,
            from the <Link
              to='https://docs.google.com/spreadsheets/d/157kNo3-xg7qeVHi8SF21VqjXKrSjHixL9UOKFTp8PKQ/edit#gid=769793980'
              title='Insure Our Future Scorecard'
              xstrong
            >
              Insure Our Future Scorecard
            </Link>.
            The data rates the fossil fuel
            insurance policies of these companies.
            For our fund ratings, we normalize the insurance policy ratings
           to a 0-10
            scale, where 10 is the worst score possible.
            These 0-10 figures represent a <b>company fossil fuel
            insurance risk score</b>.</span>),
        0, // 1 if higher risk,
        0, // 1 if has company table,
        1, // 1 if has alt slidedown,
        (<div styleName='finance-company-table-img-wrap'>
          <img
            src={fossilFuelInsuranceCompanyTable}
            alt='Fossil fuel insurance company table'
            styleName='finance-company-table-img'
          />
        </div>)
      ],
    ]

    const cleanEnergyCompaniesConfig = [
      [
        'cl',
        'Clean energy leaders',
        (<span><Link xstrong to={config.routes.clean200} title='Clean200'>The Clean200</Link> are the largest 200 public companies ranked by green energy revenues. The dataset is developed by multiplying a company’s most recent year-end revenues by its clean revenue estimate, primarily sourced from Corporate Knights Research supplemented by FactSet, Bloomberg BNEF, and FTSE Russell data. In order to be eligible, a company must have USD revenue of at least $1 billion (most recent available fiscal year-end data) and earn more than 10% of total revenues from clean sources, which extends beyond energy efficiency, green energy, and zero emission and hybrid vehicles. We include banks that are financing the low-carbon solutions; real estate companies leading the way on low-carbon buildings; forestry companies protecting carbon sinks; responsible miners of critical materials for the low carbon economy; food and apparel companies with products that are primarily made of raw materials with a significantly lower carbon footprint; and energy-hungry information and communications technology companies that are leading the way on renewable energy. A small number of utilities that have fossil fuel operations but have over 50% of total revenue from green sources are included. The Clean200 was created by As You Sow and Corporate Knights.</span>),
        0, // 1 if higher risk,
        1, // 1 if has company table,
        0, // 1 if has alt slidedown,
        0, // elem if has alt elem
      ],
    ]

    //
    return <div styleName='main-wrap'>

      {
        !this.props.clean200 ?
          <div>
            {
              fossilFuelCompaniesConfig.map((e, i) => {
                return <ScreenedCompaniesCard
                  k={`screened-company-card-${i}-0`}
                  e={e}
                  icon={icons[e[0]]}
                  getCompanies={id => { return this.state[`${id}Companies`] }}
                />
              })
            }

            <br/>
            <br/>
            <p styleName='p'>
              We also search for investments in financial industry companies that
              are financing and insuring the fossil fuel industry. <Link
              to={config.routes.banksInsurance}
              title='Fossil fuel finance & insurance'
              xstrong
              >
                Read more<LinkIcon/>
              </Link>
            </p>
            <br/>
            <br/>

            {
              fossilFinanceCompaniesConfig.map((e, i) => {
                return <ScreenedCompaniesCard
                  k={`screened-company-card-${i}-1`}
                  e={e}
                  icon={icons[e[0]]}
                  getCompanies={id => { return this.state[`${id}Companies`] }}
                />
              })
            }

            <br/>
            <br/>
            <p styleName='p'>
              We also search for investments in companies that are leading the way
              with solutions for the transition to clean energy. <Link
                to={config.routes.clean200}
                title='Clean200'
                xstrong
              >
                Read more<LinkIcon/>
              </Link>
            </p>
            <br/>
            <br/>
          </div> :
          null
      }

      <div styleName='anchor' id='clean200' />
      {
        cleanEnergyCompaniesConfig.map((e, i) => {
          return <ScreenedCompaniesCard
            k={`screened-company-card-${i}-2`}
            e={e}
            icon={icons[e[0]]}
            getCompanies={id => { return this.state[`${id}Companies`] }}
            clean200={this.props.clean200}
          />
        })
      }

    </div>
  }
}

